import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import type { TaskSnapshot, TaskStatus } from '../../api/tasks';

dayjs.extend(relativeTime);

export const STATUS_COLOR: Record<TaskStatus, string> = {
  QUEUED: 'default',
  RUNNING: 'processing',
  SUCCEEDED: 'success',
  FAILED: 'error',
  CANCELED: 'warning',
};

export const isActiveStatus = (status: TaskStatus) => status === 'RUNNING' || status === 'QUEUED';

export const isTerminalStatus = (status: TaskStatus) =>
  status === 'SUCCEEDED' || status === 'FAILED' || status === 'CANCELED';

export const formatProgress = (task: TaskSnapshot) => {
  if (task.progress?.percent !== undefined && task.progress?.percent !== null) {
    return Math.round(task.progress.percent);
  }
  if (task.progress?.processed !== undefined && task.progress?.total) {
    return Math.round((task.progress.processed / task.progress.total) * 100);
  }
  return undefined;
};

export const formatRelativeTime = (timestamp?: string) => (timestamp ? dayjs(timestamp).fromNow() : '');

export const formatAbsoluteTime = (timestamp?: string | null): string => {
  if (!timestamp) return '';
  return dayjs(timestamp).format('MMM D HH:mm:ss');
};

export const formatDuration = (startedAt?: string | null, finishedAt?: string | null): string => {
  if (!startedAt || !finishedAt) return '';
  const start = dayjs(startedAt);
  const end = dayjs(finishedAt);
  const duration = end.diff(start, 'second');

  if (duration < 60) {
    return `${duration}s`;
  } else if (duration < 3600) {
    const minutes = Math.floor(duration / 60);
    const seconds = duration % 60;
    return seconds > 0 ? `${minutes}m ${seconds}s` : `${minutes}m`;
  } else {
    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration % 3600) / 60);
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  }
};
